
export interface DataLayerEvent {
  event: string;
  data?: any;
}

export function pushEvent(e: DataLayerEvent) {
  if(typeof window.gtag !== 'function') return;

  window.gtag("event", e.event, e.data);
}

export function isAgent() {
  const path = window.location.pathname;
  return path.includes('/agent/');
}